const gfilters = {
  truncateText(text: string, maxLength: number): string {
    return text.length <= maxLength ? text : text.slice(0, maxLength) + '…';
  },
  formatCurrency(value: number, currencySymbol: string = '$'): string {
    return `${currencySymbol}${value.toFixed(2)}`;
  },
  displayText(text: string = '') {
    return text.split('_').join(' ')
  }
};

export default gfilters;